import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Plyr from "plyr-react";
import "plyr-react/plyr.css";
import { searchFilesByModule } from "../../services/FilesService/FilesService";
import toast from "react-hot-toast";
import SimpleLoader from "../Loader/SimpleLoader";
import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import { extractYoutubeId } from "../../utils/youtube";

// Generic detail page for a video module: YouTube player via Plyr.
const VideoModuleDetail = ({ moduleCode, routeBase }) => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchVideo = async () => {
      try {
        const res = await searchFilesByModule({ module_code: moduleCode });
        if (cancelled) return;
        const match = res?.files?.find((v) => v.uuid === uuid);
        if (!match) {
          toast.error("Видео табылмады.");
        }
        setVideo(match || null);
      } catch (err) {
        if (cancelled) return;
        toast.error("Қате орын алды.");
        console.error(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchVideo();
    return () => {
      cancelled = true;
    };
  }, [uuid, moduleCode]);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-20">
        <SimpleLoader className="w-10 h-10 text-[#674da2]" />
      </div>
    );
  }

  if (!video) {
    return (
      <div className="text-center text-gray-500 mt-10">
        Видео табылмады немесе сілтеме дұрыс емес.
      </div>
    );
  }

  const videoId = extractYoutubeId(video.link);

  if (!videoId) {
    return (
      <div className="text-center text-red-500 mt-10">
        Видео сілтемесі дұрыс емес.
      </div>
    );
  }

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <button
        onClick={() => navigate(routeBase)}
        className="flex items-center text-[#674da2] mb-4 hover:underline"
      >
        <ArrowLeftIcon className="w-5 h-5 mr-1" />
        Артқа
      </button>
      <h1 className="text-xl font-bold mb-4 text-center text-[#674da2]">
        {video.label || "Видео"}
      </h1>

      <div className="w-full sm:h-40 md:h-96 aspect-video  max-w-4xl mx-auto">
        <Plyr
          source={{
            type: "video",
            sources: [
              {
                src: videoId,
                provider: "youtube",
              },
            ],
          }}
          options={{
            ratio: "16:9",
            youtube: {
              noCookie: true,
              modestbranding: 1,
              rel: 0,
            },
            controls: [
              "play-large",
              "play",
              "progress",
              "current-time",
              "mute",
              "volume",
              "captions",
              "settings",
              "pip",
              "airplay",
              "fullscreen",
            ],
            settings: ["captions", "quality", "speed", "loop"],
          }}
        />
      </div>
    </div>
  );
};

export default VideoModuleDetail;
